"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NotificationEventAction () {
        return NotificationEventAction;
    },
    get NotificationEventModel () {
        return NotificationEventModel;
    },
    get NotificationIntegrationHistoryModel () {
        return NotificationIntegrationHistoryModel;
    },
    get NotificationIntegrationModel () {
        return NotificationIntegrationModel;
    },
    get NotificationIntegrationType () {
        return NotificationIntegrationType;
    },
    get NotificationModel () {
        return NotificationModel;
    },
    get ScheduledNotificationModel () {
        return ScheduledNotificationModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _integration = require("./integration");
const _review = require("./review");
const _reviews = require("./reviews");
const NotificationEventAction = _zod.z.enum([
    "feedback-created",
    "feedback-deleted",
    "feedback-subject-changed",
    "feedback-visibility-changed",
    "review-cycle-created",
    "review-cycle-start-date-changed",
    "review-cycle-closed",
    "review-cycle-deleted",
    "review-cycle-name-changed",
    "review-cycle-status-changed",
    "review-created",
    "review-closed",
    "review-changed",
    "review-reopened",
    "review-start-date-changed",
    "review-deleted",
    "review-completed",
    "review-report-created",
    "review-report-closed",
    "review-report-reopened",
    "review-report-deleted",
    "review-report-start-date-changed",
    "review-report-due-date-changed",
    "review-report-submitted",
    "review-report-saved-for-later",
    "review-report-signed",
    "review-report-sent-back",
    "review-report-visibility-changed",
    "review-report-authors-changed",
    "review-report-signers-changed",
    "external-review-report-created",
    "review-report-bulk-due-dates-changed",
    "easy-add-review-report-created",
    "easy-add-review-report-approved",
    "easy-add-review-report-awaiting-approval-deleted",
    "todo-created",
    "todo-deleted",
    "todo-completed",
    "todo-sent-back",
    "todo-due-date-changed",
    "goal-created",
    "goal-updated",
    "goal-status-changed",
    "goal-deleted",
    "goal-due-date-changed",
    "goal-sharer-added",
    "goal-sharer-removed",
    "goal-category-added",
    "goal-category-removed",
    "goal-checklist-item-added",
    "goal-checklist-item-removed",
    "goal-checklist-item-checked",
    "goal-checklist-item-unchecked",
    "goal-transparency-changed",
    "goal-assignee-changed",
    "goal-alignment-changed",
    "goal-commented-on",
    "company-function-disabled",
    "company-function-enabled",
    "data-field-changed",
    "user-created",
    "user-deactivated",
    "user-reactivated",
    "user-role-changed",
    "new-strategy-assigned",
    "new-strategy-assigned-to-team",
    "survey-created",
    "survey-updated",
    "survey-deleted",
    "survey-response-submitted"
]);
const NotificationIntegrationType = _zod.z.enum([
    "slack"
]);
const NotificationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    author: _zod.z.instanceof(_bson.ObjectId).optional(),
    "available-end": _zod.z.date().optional(),
    "available-start": _zod.z.date(),
    commenter: _zod.z.instanceof(_bson.ObjectId).optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    date_sent: _zod.z.date().optional(),
    feedback: _zod.z.instanceof(_bson.ObjectId).optional(),
    notification: _zod.z.string(),
    recognition: _zod.z.instanceof(_bson.ObjectId).optional(),
    recognizee: _zod.z.instanceof(_bson.ObjectId).optional(),
    recognizer: _zod.z.instanceof(_bson.ObjectId).optional(),
    review: _zod.z.instanceof(_bson.ObjectId).optional(),
    review_report: _zod.z.instanceof(_bson.ObjectId).optional(),
    sent: _zod.z.boolean(),
    strategy: _zod.z.instanceof(_bson.ObjectId).optional(),
    subject: _zod.z.instanceof(_bson.ObjectId).optional(),
    user: _zod.z.instanceof(_bson.ObjectId).optional()
});
const NotificationIntegrationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    access_token: _zod.z.string(),
    company: _zod.z.instanceof(_bson.ObjectId),
    deleted: _zod.z.boolean(),
    settings: _zod.z.object({
        chanel_id: _zod.z.string(),
        channel_name: _zod.z.string().optional(),
        configuration_url: _zod.z.string().optional(),
        incoming_webhook_url: _zod.z.string().optional()
    }),
    type: NotificationIntegrationType
});
const NotificationIntegrationHistoryModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    access_token: _zod.z.string(),
    app_id: _zod.z.string().optional(),
    authed_user: _zod.z.object({
        id: _zod.z.string()
    }).optional(),
    bot_user_id: _zod.z.string().optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    incoming_webhook: _zod.z.object({
        channel: _zod.z.string(),
        channel_id: _zod.z.string(),
        configuration_url: _zod.z.string(),
        url: _zod.z.string()
    }),
    is_enterprise_install: _zod.z.boolean().optional(),
    notification_integration: _zod.z.instanceof(_bson.ObjectId),
    ok: _zod.z.boolean(),
    scope: _zod.z.string(),
    team: _zod.z.object({
        id: _zod.z.string(),
        name: _zod.z.string()
    }).optional(),
    team_id: _zod.z.string().optional(),
    team_name: _zod.z.string().optional(),
    token_type: _zod.z.string().optional(),
    type: _integration.IntegrationType,
    user: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.string().optional()
});
const NotificationEventModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    action: NotificationEventAction,
    actor: _zod.z.instanceof(_bson.ObjectId).nullable(),
    company: _zod.z.instanceof(_bson.ObjectId),
    metadata: _zod.z.object({
        answers: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())).optional(),
        as_of: _zod.z.date().optional(),
        current_value: _zod.z.union([
            _zod.z.string(),
            _zod.z.number(),
            _zod.z.array(_zod.z.string()),
            _zod.z.instanceof(_bson.ObjectId),
            _zod.z.date(),
            _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
            _zod.z.record(_zod.z.string(), _zod.z.unknown())
        ]).optional().nullable(),
        cycle: _zod.z.string().optional(),
        cycle_id: _zod.z.string().optional(),
        field: _zod.z.instanceof(_bson.ObjectId).optional(),
        field_id: _zod.z.instanceof(_bson.ObjectId).optional(),
        function: _zod.z.string().optional(),
        goal_id: _zod.z.instanceof(_bson.ObjectId).optional(),
        review_id: _zod.z.instanceof(_bson.ObjectId).optional(),
        review: _review.ReviewModel.optional(),
        review_report_id: _zod.z.instanceof(_bson.ObjectId).optional(),
        review_report: _reviews.ReviewReportModel.optional(),
        todo: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
        todo_id: _zod.z.string().optional(),
        update: _zod.z.object({
            action: _zod.z.string().optional(),
            color: _zod.z.string().optional().nullable(),
            last_update: _zod.z.date().optional().nullable(),
            seen_by: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
            status: _zod.z.string().optional().nullable(),
            value: _zod.z.number().optional().nullable(),
            old_author: _zod.z.instanceof(_bson.ObjectId).optional(),
            old_authors: _zod.z.array(_zod.z.union([
                _zod.z.instanceof(_bson.ObjectId),
                _zod.z.null()
            ])).optional(),
            old_author_turn: _zod.z.number().optional(),
            old_signer: _zod.z.instanceof(_bson.ObjectId).optional(),
            old_signers: _zod.z.array(_zod.z.union([
                _zod.z.instanceof(_bson.ObjectId),
                _zod.z.null()
            ])).optional(),
            old_signer_turn: _zod.z.number().optional()
        }).optional(),
        user: _zod.z.instanceof(_bson.ObjectId).optional(),
        user_id: _zod.z.instanceof(_bson.ObjectId).optional(),
        value: _zod.z.union([
            _zod.z.string(),
            _zod.z.number(),
            _zod.z.array(_zod.z.string()),
            _zod.z.instanceof(_bson.ObjectId),
            _zod.z.date(),
            _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
            _zod.z.record(_zod.z.string(), _zod.z.unknown())
        ]).optional().nullable(),
        values: _zod.z.array(_zod.z.union([
            _zod.z.string(),
            _zod.z.null(),
            _zod.z.number(),
            _zod.z.array(_zod.z.string()),
            _zod.z.instanceof(_bson.ObjectId),
            _zod.z.date(),
            _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
            _zod.z.record(_zod.z.string(), _zod.z.unknown())
        ])).optional().nullable(),
        request_id: _zod.z.instanceof(_bson.ObjectId).optional(),
        stage: _zod.z.string().optional(),
        status: _zod.z.string().optional(),
        status_updated_at: _zod.z.date().optional(),
        lastSeen: _zod.z.date().optional()
    }).optional(),
    attempt_count: _zod.z.number(),
    status: _zod.z.union([
        _zod.z.literal("pending"),
        _zod.z.literal("processed"),
        _zod.z.literal("failed"),
        _zod.z.literal("unprocessed")
    ]),
    status_updated_at: _zod.z.date(),
    request_id: _zod.z.instanceof(_bson.ObjectId).nullable().optional(),
    deleted: _zod.z.boolean(),
    stage: _zod.z.string().optional()
});
const ScheduledNotificationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    cancellation_event: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    event: _zod.z.record(_zod.z.string(), _zod.z.unknown()),
    fetched_at: _zod.z.date().optional(),
    metadata: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    not_after: _zod.z.date(),
    not_before: _zod.z.date(),
    notification_name: _zod.z.string(),
    recipient: _zod.z.instanceof(_bson.ObjectId),
    sent_status: _zod.z.string(),
    stage: _zod.z.string()
});
